import flagsClient from 'rpc/flagsClient';
import {
  GetFlagRequest,
  GetFlagsRequest,
  GetFlagResponse,
} from 'rpc/model/squareup/feature/relay/flags/message/get_flags';
import { v4 as uuidv4 } from 'uuid';
import { Token } from 'rpc/model/squareup/feature/relay/common/token';
import { Status } from 'rpc/model/squareup/feature/relay/flags/message/status';

export async function fetchFlags(
  flagRequests: GetFlagRequest[],
  token: string = uuidv4(),
  userEmail?: string,
  country?: string
): Promise<readonly GetFlagResponse[]> {
  const userAttributes = userEmail
    ? {
        userAttributes: [
          {
            name: 'email',
            stringValue: userEmail,
          },
          ...(country
            ? [
                {
                  name: 'country',
                  stringValue: country,
                },
              ]
            : []),
        ],
      }
    : undefined;

  const response = await flagsClient.getFlags(
    GetFlagsRequest.create({
      flagRequests: flagRequests.map(({ flagName, flagType, userToken }) =>
        GetFlagRequest.create({ flagName, flagType, userToken })
      ),
      projectId: 'pie',
      userAttributes,
      userToken: {
        token,
        // TODO: Figure out what this is being used for
        // and make request to #framework-services to include buyer type.
        type: Token.Type.ANONYMOUS_VISITOR,
      },
    })
  );

  if (response.status !== Status.SUCCESS) {
    throw new Error('Failed to fetch feature flags.');
  }

  return response.flagResponses;
}
